import React, { Component } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import Heading from "./Heading";
import SharedList from "./SharedList";
import CreateStaffModal from "./CreateStaffModal";
import inviteImage from "../../files/invite.png";
import { USERS_ROLE } from "../../constants/role.constant";
const _ = require("lodash");
class SharedAccount extends Component {
  constructor(props) {
    super(props);

    this.props.dispatch({
      type: "DO_GET_USERS_LIST",
    });

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      modal: false,
      modal2: false,
      modalStaff: false,
      emailOffer: "",
      emailAccess: "",
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      gender: "Male",
      showAlertSuccess: false,
      errorPassword: false,
      role: "",
      otherRole: undefined,
      isOtherRole: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleStaff = this.toggleStaff.bind(this);
    this.openInvite = this.openInvite.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleAllPatients = this.handleAllPatients.bind(this);
    this.submit = this.submit.bind(this);
    this.submitStaff = this.submitStaff.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.deleteInvitation = this.deleteInvitation.bind(this);
    this.userInputChange = this.userInputChange.bind(this);
    this.expectationInputChange = this.expectationInputChange.bind(this);
    this.handleRole = this.handleRole.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleSearch(value){
    this.setState({ searchValue: value });
  }
  handleAllPatients(staffId, search){
    const payload = { staffId };
    if(search) payload.search = search;
    this.props.dispatch({
      type: "DO_GET_ALL_STAFF_PATIENT_LIST",
      payload: payload,
    });
  }
  handleKeyDown(e){
    const inputField = e.target;
    const inputValue = inputField.value;
    const caretPosition = inputField.selectionStart;
    if (e.keyCode === 32) {
      // Check if it's the first character and if there are no non-space characters before it
      if (caretPosition === 0 || /^\s+$/.test(inputValue.substring(0, caretPosition))) {
        e.preventDefault();
      }
    }
  };
  userInputChange(eventOrArray, staffId, isSelected) {
    // Handle two call patterns:
    // - PatientList bulk selection: userInputChange([id1,id2], staffId, isSelected)
    // - Legacy checkbox event: userInputChange(event, staffId)
    const payloadStaffId = staffId;
    if (Array.isArray(eventOrArray)) {
      const ids = eventOrArray;
      if (isSelected) {
        this.props.dispatch({
          type: "DO_ADD_OR_DELETE_STAFF_PATIENT",
          payload: { staffId: payloadStaffId, isAdd: true, users: ids },
        });
      } else {
        if (ids.length < 2) {
          this.props.dispatch({
            type: "DO_ADD_OR_DELETE_STAFF_PATIENT",
            payload: { staffId: payloadStaffId, isAdd: false, user: ids[0] },
          });
        } else {
          this.props.dispatch({
            type: "DO_DELETE_ALL_STAFF_PATIENT",
            payload: { staffId: payloadStaffId, users: ids },
          });
        }
      }
    } else {
      const event = eventOrArray || {};
      const target = event.target || {};
      const isCheck = target.type === "checkbox" ? target.checked : target.value;
      const name = target.name;
      if (isCheck) {
        this.props.dispatch({
          type: "DO_ADD_OR_DELETE_STAFF_PATIENT",
          payload: { staffId: payloadStaffId, isAdd: true, users: [name] },
        });
      } else {
        this.props.dispatch({
          type: "DO_ADD_OR_DELETE_STAFF_PATIENT",
          payload: { staffId: payloadStaffId, isAdd: false, user: name },
        });
      }
    }
  }
  expectationInputChange(event, staffId, expectation) {
    const target = event.target;
    const isCheck = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (isCheck) {
      
      this.props.dispatch({
        type: "DO_ADD_OR_DELETE_EXPECTATION",
        payload: {
          staffId: staffId,
          isAdd: true,
          expectationId: expectation._id,
          expectationType: expectation.ruleType,
        },
      });
    } else {
      this.props.dispatch({
        type: "DO_ADD_OR_DELETE_EXPECTATION",
        payload: {
          staffId: staffId,
          isAdd: false,
          expectationId: expectation._id,
          expectationType: expectation.ruleType,
        },
      });
    }
    // shared-account list will be refreshed by saga on success
    // this.setState({
    //   [name]: value
    // });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    if (name === "confirmpassword") {
      const checkMatch = this.state.password === value;

      if (!checkMatch) {
        this.setState({ errorPassword: true });
      } else {
        this.setState({ errorPassword: false });
      }
    }
  }
  resetForm() {
    this.setState({
      modal2: false,
      modal: false,
      modalStaff: false,
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      gender: "Male",
      role: "",
      otherRole: undefined
    });
    this.props.dispatch({
      type: "GENERIC_ERROR",
    });
    this.props.dispatch({
      type: "DO_GET_SHARED_ACCOUNT",
    });
  }
  toggleModal() {
    
    this.setState({
      modal: !this.state.modal,
    });
  }
  toggleStaff() {
    
    this.setState({
      modalStaff: !this.state.modalStaff,
    });
  }
  openInvite() {
    
    this.setState({
      modal2: !this.state.modal2,
    });
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  deleteInvitation(id) {
    this.props.dispatch({
      type: "DO_DELETE_STAFF",
      payload: { id: id },
    });
  }
  groupByUser() {
    var result = _.chain(this.props.pmRecords)
      .groupBy("patient._id")
      .map((trackTime, userId) => ({ trackTime, userId }))
      .value();
    return result;
  }
  handleRole(e){
    if(e.target.name != 'otherRole'){
      this.setState({ role: e.target.value, otherRole: undefined });
      return;
    }
    if(this.state.role == 'Other' && e.target.name == 'otherRole'){
      this.setState({ otherRole: e.target.value });
    }else if(this.state.role != 'Other' && e.target.name != 'otherRole'){
      this.setState({ otherRole: undefined });
    }
  }
  submit(e) {
    e.preventDefault();

    this.props.dispatch({
      type: "DO_SEND_INVITE",
      payload: {
        fname: this.state.fname,
        lname: this.state.lname,
        email: this.state.email,
        isStaff: true,
        isCareProvider: false,
        role: this.state.role != 'Other' ? this.state.role : this.state.otherRole,
        isOtherRole: this.state.role != 'Other' ? false : true,
      },
    });
  }
  submitStaff(e) {
    e.preventDefault();
    this.setState({
      role: this.state.role != 'Other' ? this.state.role : this.state.otherRole,
      isOtherRole: this.state.role != 'Other' ? false : true,
    }, () => {
    const cleanStaff = _.omit(this.state, [
      "activeTab",
      "modal",
      "modal2",
      "modalStaff",
      "emailOffer",
      "confirmpassword",
      "emailAccess",
      "showAlertSuccess",
      "errorPassword",
      "otherRole"
    ]);
    this.props.dispatch({
      type: "DO_SAVE_STAFF",
      payload: cleanStaff,
    });
    // DO_GET_SHARED_ACCOUNT will be triggered by saga after successful save
  });
  }
  componentDidMount() {
    this.props.dispatch({
      type: "DO_GET_UNREAD_COUNT"
    });
    this.props.dispatch({
      type: "GENERIC_ERROR",
    });
    if (!this.props.isClient) {
      this.props.dispatch({
        type: "DO_GET_SHARED_ACCOUNT",
      });
      this.props.dispatch({
        type: "DO_GET_MY_RULES",
      });
    }
  }

  render() {    
    const search = this.state.searchValue ? this.state.searchValue.toString().toLowerCase() : "";
    const onlyActivePatients = _.orderBy(
      _.filter(this.props.assignedUsersList, (p) => p.isActive && (function(){
        if(!search) return true;
        const lname = (p.lname || "").toString().toLowerCase();
        const fname = (p.fname || "").toString().toLowerCase();
        const nickname = (p.nickname || "").toString().toLowerCase();
        const email = (p.email || "").toString().toLowerCase();
        const memberId = (p.memberId || "").toString().toLowerCase();
        return (lname.indexOf(search) !== -1 || fname.indexOf(search) !== -1 || nickname.indexOf(search) !== -1 || email.indexOf(search) !== -1 || memberId.indexOf(search) !== -1);
      })()),
      [
        (o) => (o.lname || "").toString().toLowerCase(),
        (o) => (o.fname || "").toString().toLowerCase(),
      ],
      ["asc", "asc"]
    );
    const roleOptions = USERS_ROLE.filter((item) => item.type == "Staff" && item.value == 'Shared/Family Account');
    return (
      <div>
        <div className="row">
          {this.props.isAll && (
            <Heading
              title="STAFF/SUBUSER LIST"
              description=""
              backbutton="d-none"
              mainbutton="d-none"
              toggleModal={this.toggleModal}
            >
              <span className="page-title-icon bg-gradient-danger   text-white mr-2">
                <i className="mdi mdi-account-convert" />
              </span>
            </Heading>
          )}
          {!this.props.isAll && (
            <Heading
              title={null}
              description=""
              backbutton="d-none"
              mainbutton="d-block"
              toggleModal={this.toggleModal}
            >
              <span className="page-title-icon bg-gradient-danger   text-white mr-2">
                <i className="mdi mdi-account-convert" />
              </span>
            </Heading>
          )}

          <div className="col-12 grid-margin">
            <div className="card">
              <Nav tabs className="justify-content-center">
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "1",
                    })}
                    onClick={() => {
                      this.toggle("1");
                    }}
                  >
                    Shared / Family Account
                  </NavLink>
                </NavItem>
              </Nav>
              <div className="card-body project-tab pt-2">
                <Row>
                  <Col sm="12" className="grid-margin mt-4">
                    {this.props.ongoingSharedAccountListRequest && (
                      <SharedList
                        usersOfferedAccess={onlyActivePatients}
                        expectations={this.props.myRules}
                        loading={this.props.ongoingSharedAccountListRequest}
                        deleteInvitation={this.deleteInvitation}
                        sharedAccount={[]}
                        userInputChange={this.userInputChange}
                        expectationInputChange={this.expectationInputChange}
                        onSearch={this.handleSearch}
                        searchValue={this.state.searchValue}
                        handleAllPatients={this.handleAllPatients}
                        allStaffPatientList={this.props.allStaffPatientList}
                        ongoingAssignedUserRequest={this.props.ongoingAssignedUserRequest}
                      />
                    )}
                    {!this.props.ongoingSharedAccountListRequest && this.props.sharedAccount && (
                      <SharedList
                        usersOfferedAccess={onlyActivePatients}
                        expectations={this.props.myRules}
                        loading={this.props.ongoingSharedAccountListRequest}
                        deleteInvitation={this.deleteInvitation}
                        sharedAccount={this.props.sharedAccount}
                        userInputChange={this.userInputChange}
                        expectationInputChange={this.expectationInputChange}
                        onSearch={this.handleSearch}
                        searchValue={this.state.searchValue}
                        handleAllPatients={this.handleAllPatients}
                        allStaffPatientList={this.props.allStaffPatientList}
                        ongoingAssignedUserRequest={this.props.ongoingAssignedUserRequest}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleModal}>
            Create A New Shared / Family Account
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <h5 className="text-center" />
            <div className="row">
              {this.props.isClient && (
                <div className="col-12">
                  <NavLink
                    className="text-center d-block"
                    onClick={this.toggleStaff}
                  >
                    <img
                      src="https://img.freepik.com/free-vector/cute-doctor-couple_57812-25.jpg?size=338&ext=jpg"
                      style={{ height: "180px" }}
                    />
                    <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                      CREATE A NEW STAFF ACCOUNT
                    </span>
                    <small>You will input everything</small>
                  </NavLink>
                </div>
              )}
              {!this.props.isClient && (
                <div className="col-12 col-md-6">
                  <NavLink
                    className="text-center d-block"
                    onClick={this.openInvite}
                  >
                    <img src={inviteImage} style={{ height: "180px" }} />
                    <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                      INVITE A USER
                    </span>
                    <small>Send a sign up link</small>
                  </NavLink>
                </div>
              )}
              {!this.props.isClient && (
                <div className="col-12 col-md-6">
                  <NavLink
                    className="text-center d-block"
                    onClick={this.toggleStaff}
                  >
                    <img
                      src="https://img.freepik.com/free-vector/cute-doctor-couple_57812-25.jpg?size=338&ext=jpg"
                      style={{ height: "180px" }}
                    />
                    <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                      CREATE A NEW STAFF ACCOUNT
                    </span>
                    <small>You will input everything</small>
                  </NavLink>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modal2}
          toggle={this.openInvite}
          className={this.props.className}
        >
          <ModalHeader toggle={this.openInvite}>
            Send an invite link
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <Form onSubmit={this.submit}>
              <FormGroup>
                <Label for="exampleText">First Name</Label>
                <Input
                  type="text"
                  name="fname"
                  required={true}
                  onChange={this.handleInputChange}
                  rows={10}
                />
              </FormGroup>
              <FormGroup>
                <Label for="exampleText">Last Name</Label>
                <Input
                  type="text"
                  name="lname"
                  required={true}
                  onChange={this.handleInputChange}
                  rows={10}
                />
              </FormGroup>
              <FormGroup>
                <Label for="exampleText">Role *</Label>
                <select
                  name="role"
                  className="form-control"
                  onChange={this.handleRole}
                  required
                >
                <option value="">
                  Select Role
                </option>
                {roleOptions.map((option) => (
                  <option value={option.value}>{option.role}</option>
                ))}
              </select>
              </FormGroup>
              {(this.state.role == 'Other' || this.state.otherRole != undefined) && (
              <FormGroup>
                <Label for="exampleText">
                Other Role *
                </Label>
                <Input
                  type="text"
                  required={this.state.role == 'Other' ? true : false}
                  name="otherRole"
                  onChange={this.handleRole}
                  onKeyDown={this.handleKeyDown}
                />
              </FormGroup>
              )}
              <FormGroup>
                <Label for="exampleText">Email</Label>
                <Input
                  type="email"
                  name="email"
                  required={true}
                  onChange={this.handleInputChange}
                  rows={10}
                />
              </FormGroup>
              <button type="submit" className="btn btn-block btn-info">
                Send
              </button>
            </Form>
          </ModalBody>
        </Modal>
        <CreateStaffModal
          modalStaff={this.state.modalStaff}
          toggleStaff={this.toggleStaff}
          errorPassword={this.state.errorPassword}
          submitStaff={this.submitStaff}
          handleInputChange={this.handleInputChange}
          handleRole={this.handleRole}
          role = {this.state.role}
          handleKeyDown = {this.handleKeyDown}
        />
        <SweetAlert
          success
          title="Success!"
          show={this.props.isGenericSuccess}
          onConfirm={this.resetForm}
          confirmBtnBsStyle="info"
        >
          {!this.state.bday && (
            <div>
              Submitted Successfully Invitation is Sent to {this.state.email}
            </div>
          )}
          {this.state.bday && <div>Staff Created Successfully</div>}
        </SweetAlert>
        <SweetAlert
          error
          title={this.props.genericErrorMessage.message}
          show={this.props.isGenericError}
          onConfirm={() => {
            this.props.dispatch({
              type: "GENERIC_ERROR",
            });
          }}
          confirmBtnBsStyle="danger"
          timeout={1000}
        >
          Error Code: {this.props.genericErrorMessage.error}
        </SweetAlert>
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    readingSubTypes,
    pmRecords,
    sharedAccount,
    assignedUsersList,
    myRules,
    ongoingSharedAccountListRequest,
    allStaffPatientList,
    ongoingAssignedUserRequest,
  } = careprovider;
  const userId = user.userDetails._id;

  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    readingSubTypes,
    pmRecords,
    userId,
    sharedAccount,
    assignedUsersList,
    ongoingSharedAccountListRequest,
    ongoingAssignedUserRequest,
    allStaffPatientList,
    myRules,
  };
};

export default connect(mapStateToProps)(SharedAccount);

